export default "__VITE_ASSET__BDJ$Uuj5__"